export class Config {
    public endpoint: string = 'https://account.kemnaker.go.id';
    public clientId: string;

    public constructor(data?: Partial<Config>) {
        Object.assign(this, data);
    }
}
